import { tool } from "ai";
import { z } from "zod";
import type { YTRankClient } from "../ytrank-client";

function YTRankAISDK(ytrank: YTRankClient) {
  return tool({
    description: "Transcribe a YouTube video",
    parameters: z.object({
      url: z.string().describe("The URL of the YouTube video to transcribe"),
    }),
    execute: async ({ url }: { url: string }) => {
      const response = await ytrank.getTranscript(url);
      return response;
    },
  });
}

export { YTRankAISDK };
